import { useIsomorphicLayoutEffect } from '@/hooks/Custom'
import { Flex, Text } from '@chakra-ui/react'
import { useState } from 'react'

function useCountdown(seconds: number) {
    const [CountDownDate, setCountDownDate] = useState(null)

    if (localStorage.getItem('CountDownDate') === null) {
        const Scrap = new Date()
        setCountDownDate(Scrap.setSeconds(Scrap.getSeconds() + seconds))
        localStorage.setItem('CountDownDate', CountDownDate.toString())
    } else {
        setCountDownDate(
            new Date(localStorage.getItem('CountDownDate')).getSeconds()
        )
    }

    const [CountDown, setCountDown] = useState(
        CountDownDate - new Date().getTime()
    )

    const getReturnValues = (CountDown) => {
        const minutes = Math.floor((CountDown % (1000 * 60 * 60)) / (1000 * 60))
            .toString()
            .padStart(2, '0')
        const seconds = Math.floor((CountDown % (1000 * 60)) / 1000)
            .toString()
            .padStart(2, '0')

        return [minutes, seconds]
    }

    useIsomorphicLayoutEffect(() => {
        const interval = setInterval(() => {
            setCountDown(CountDownDate - new Date().getTime())
            localStorage.setItem('CountDownDate', CountDownDate.toString())
        }, 1000)

        return () => clearInterval(interval)
    }, [CountDownDate])

    return getReturnValues(CountDown)
}

export { useCountdown }
